import { Component, Input, inject } from '@angular/core';
import { ModalController, IonicModule } from '@ionic/angular';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { LicenseMetadata } from '../../../licenses.model';
import { AppLauncher } from '@capacitor/app-launcher';

@Component({
    selector: 'app-license-details',
    templateUrl: './license-details.component.html',
    styleUrls: ['./license-details.component.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class LicenseDetailsComponent {
  translate = inject(TranslateService);
  modalController = inject(ModalController);


  @Input() license: LicenseMetadata;

  wrapLicenseTexts = true;

  public openURL(url: string): void {
    AppLauncher.openUrl({ url });
  }
}
